import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import { validate } from "shared/yup";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell } from "../widget-fields";
import { FormField } from "component/shared/form-fields";
import { registrationFormSchema } from "./validation";
import { getUser } from "redux/selector";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	redirectUrl: string,
	buttonText: string,
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			redirectUrl: "",
			buttonText: "",
		}
	}

	private validationSchema = registrationFormSchema;

	public render() {
		const { user } = this.props;
		const { redirectUrl, buttonText} = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.registrationFormWidget(
			user.websitePlatform,
			redirectUrl || undefined,
			buttonText || undefined,
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell full>
						<FormField
							label="Redirect URL"
							value={redirectUrl}
							onChange={(event) => this.setState({redirectUrl: event.target.value})}
							error={!!(redirectUrl && errors?.redirectUrl)}
							helperText={(redirectUrl && errors?.redirectUrl) || undefined}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell full>
						<FormField
							label="Button Text"
							value={buttonText}
							onChange={(event) => this.setState({buttonText: event.target.value})}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>
		);
	}
}

export const RegistrationFormConfig = connect(mapStateToProps, mapDispatchToProps)(Component);